import React, { useState, useRef, useEffect } from "react";
import { gsap } from "gsap";

// Material-UI Components
import { Box, IconButton, Typography } from "@mui/material";

// Material-UI Icons
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

function Card(props) {
  const { member } = props;

  const [isHovered, setIsHovered] = useState(false);
  const hoverBoxRef = useRef();

  useEffect(() => {
    if (isHovered) {
      // Animate the box when hovered
      gsap.to(hoverBoxRef.current, {
        height: "auto", // Expands to fit content
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
      });
    } else {
      // Animate the box when hover is removed
      gsap.to(hoverBoxRef.current, {
        height: 0,
        opacity: 0,
        duration: 0.5,
        ease: "power2.in",
      });
    }
  }, [isHovered]);

  return (
    <Box
      sx={{
        mx: 2,
        my: 7,
        width: "fit-content",
        bgcolor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        borderRadius: 4,
        position: "relative",
      }}
      onMouseEnter={() => setIsHovered(true)} // Set hovered to true
      onMouseLeave={() => setIsHovered(false)} // Set hovered to false
    >
      <img
        src={member.photo}
        alt={member.name}
        style={{
          height: "440px",
          width: "360px",
          objectFit: "cover",
          background: "none",
          borderRadius: 12,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          transform: "translateY(0%)",
          width: "100%",
          bgcolor: "black",
          color: "white",
          borderRadius: 3,
          py: 1,
          px: 2,
          overflow: "hidden", // Hide overflowing content during animation
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ color: "white" }}>
            <Typography fontWeight="bold" sx={{ my: "2px" }}>
              {member.name}
            </Typography>
            <Typography
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.15)",
                textAlign: "center",
                borderRadius: 1,
                width: "fit-content",
                px: "10px",
              }}
            >
              {member.position}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignContent: "center",
            }}
          >
            {member.github === "#" ? null : (
              <IconButton
                sx={{
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  ml: 1,
                  "&:hover": { bgcolor: "rgba(255, 255, 255, 0.2)" },
                }}
                onClick={() => window.open(member.github, "_blank")}
              >
                <GitHubIcon sx={{ color: "white" }} />
              </IconButton>
            )}
            {member.linkedin === "#" ? null : (
              <IconButton
                sx={{
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  ml: 1,
                  "&:hover": { bgcolor: "rgba(255, 255, 255, 0.2)" },
                }}
                onClick={() => window.open(member.linkedin, "_blank")}
              >
                <LinkedInIcon sx={{ color: "white" }} />
              </IconButton>
            )}
          </Box>
        </Box>
        <Box
          ref={hoverBoxRef}
          sx={{
            overflow: "hidden",
            height: 0, // Initial height
            opacity: 0, // Initial opacity
          }}
        >
          {member?.primary_techstack && member?.about ? (
            <Box>
              <Box
                sx={{
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  p: 1,
                  my: 1,
                  borderRadius: 3,
                }}
              >
                <Typography fontWeight="bold">Primary Techstack</Typography>
                <Typography>{member.primary_techstack}</Typography>
              </Box>
              <Box
                sx={{
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  p: 1,
                  my: 1,
                  borderRadius: 3,
                }}
              >
                <Typography fontWeight="bold">About</Typography>
                <Typography>{member.about}</Typography>
              </Box>
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}

export default Card;
